import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";



const AddPlan = () => {
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [serviceID, setServiceID] = useState('');
    const [serviceData, setServiceData] = useState([]);
    const [PackageID, setPackageID] = useState('');
    const [packageData, setPackageData] = useState([]);
    const [featureData, setFeatureData] = useState([]);

    const [noOfmessage,setNoOfmessage] = useState('');
    const [noOfBuyContacts,setNoOfBuyContacts] = useState('');
    const [subType,setSubType] = useState('');
    const [price,setPrice] = useState('');

    const [featureArr,setFeatureArr] = useState([]);
    const [featureKey,setFeatureKey] = useState([]);
   
    // const Navigate = useNavigate();

    const addPlanApi = () => {
        console.log(serviceID,PackageID,subType,price,featureArr);
        // const featureIds = [];
        // const featureTitles = [];
        // for (let i = 0; i < featureData.length; i++) {
        //     if (featureData[i].isChecked === true) {
        //         featureIds.push(featureData[i].feature_id);
        //         featureTitles.push(featureData[i].feature_title);
        //         console.log(featureData[i].feature_id);
        //     }
        // }

        for(let i=0;i<featureArr.length;i++){
            featureArr[i].key = featureKey[i].key;
        }
        console.log("enter");
        Axios
            .post("api/bussiness/create-plan", {
                service_id: serviceID,
                package_id:PackageID,
                subscription_type:subType,
                price:price,
                feature_info : featureArr,
                // no_of_message:noOfmessage,
                // no_of_buy_contacts:noOfBuyContacts,
                // feature_id:featureIds,
                // feature_title:featureTitles
            })
            .then((response) => {
                console.log(response);
                setNotify({
                    isOpen: true,
                    messsage: "Added Successfully",
                    type: 'success'
                })
            }).catch((error) => {
                // setNotify({
                //     isOpen: true,
                //     messsage: "already exits service",
                //     type: 'warning'
                // })
            });
            
    }

    const serviceApi = async (e) => {
        Axios
            .get(`/api/bussiness/get-plan-service-data`, {
            }).then((response) => {
                console.log(response);
                console.log(response.data.data.PlanServiceList[0])
                setServiceData(response.data.data.PlanServiceList[0]);
            }).catch(() => {
                console.log("Invalid Credentials");
            });
    }
    const serviceList = serviceData.map((list) => {
        return (
            <option key={list.service_id} value={list.service_id}>{list.service_name}</option>
        )
    })

    const packageApi = async (e) => {
        Axios
            .get(`/api/bussiness/get-plan-package-data?service_id=${serviceID}`, {
            }).then((response) => {
                console.log(response);
                console.log(response.data.data.PlanServiceList[0])
                setPackageData(response.data.data.PlanServiceList[0]);
            }).catch(() => {
                console.log("Invalid Credentials");
            });
        console.log(PackageID);
    }
    const packageList = packageData.map((list) => {
        return (
            <option key={list.package_id} value={list.package_id}>{list.package_name}</option>
        )
    })

    const featureApi = ()=>{
        console.log(serviceID,PackageID)
        // alert("hello",serviceID,PackageID);
        Axios
            .get(`api/bussiness/service-package-feature-listing?service_id=${serviceID}&package_id=${PackageID}`, {
            }).then((response) => {
                console.log("from feature",response.data.data.listingFeature);
                setFeatureData(response.data.data.listingFeature);
            }).catch((error) => {
                console.log("feature Invalid Credentials",error);
            });
        console.log(PackageID);
    }
    console.log(featureData);

    useEffect(()=>{
        if(PackageID && serviceID){
            featureApi();
        }
    },[PackageID,serviceID]);


    const handleChange = (e) => {
        const { name, checked } = e.target;
        console.log(name);
        let tempGroup = featureData.map((plan) =>
                plan.feature_id === name ? { ...plan, isChecked: checked } : plan
        );
        setFeatureData(tempGroup);
    }

    const featureValuefunc = (e,index) => {
        let featureInfo = [...featureArr];
        featureInfo[index] = {
            feature_title:featureData[index].feature_title,
            feature_id:featureData[index].feature_id,
            feature_value: e.target.value,
        }
        setFeatureArr([...featureInfo]);
    }


    const featureKeysFunc = (e,index) => {
        let featureArr = [...featureKey];
        featureArr[index] = {
            feature_id:featureData[index].feature_id,
            key:e.target.value
        }
        setFeatureKey([...featureArr]);
    }



    const featureUilist = featureData.map((list,index)=>{
            return (
                <p>
                    <input
                    type="checkbox"
                    name={list.feature_id}
                    checked={list?.isChecked}
                    onChange={handleChange}
                   />
                    {list.feature_title}
                    &nbsp;&nbsp;
                   <input type="number" onChange={(e)=>{featureValuefunc(e,index)}}></input>
                   <input type="text" onChange={(e)=>{featureKeysFunc(e,index)}}></input>
                </p>
            )
        
    })

    // const featureUilistText = featureData.map((list)=>{
    //     if(list.feature_ui == "text"){
    //         return (
    //             <p>{list.feature_title}<input type="text"/></p>
    //         )
    //     }
    // })

    // const featureUilistDropDown = featureData.map((list)=>{
    //     if(list.feature_ui == "dropdown"){
    //         return (
    //             <p>{list.feature_title}< type="dropdown"/></p>
    //         )
    //     }
    // })

    

    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                    <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Add Plan</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="card-box" style={{ width: "50%",marginTop:"10px"}}>
                            <div className="form-group mb-3">
                                <label htmlFor="service">Select Services</label>
                                <select
                                    onChange={(e) => { setServiceID(e.target.value) }}
                                    id="service"
                                    type="text"
                                    className="form-control"
                                    onClick={serviceApi}
                                    style={{
                                        height: "50px", width: "100%"
                                    }}>
                                    <option>Select Services</option>
                                    {serviceList}
                                </select>
                            </div>

                            <div className="form-group mb-3">
                                <label htmlFor="package">Select Package</label>
                                <select
                                    onChange={(e) => { setPackageID(e.target.value) }}
                                    id="package"
                                    type="text"
                                    className="form-control"
                                    onClick={packageApi}
                                    style={{
                                        height: "50px", width: "100%"
                                    }}>
                                    <option>Select Package</option>
                                    {packageList}
                                </select>
                            </div>

                            {featureUilist}

                            {/* <div className="form-group mb-3">
                                    <label htmlFor="NoOfmessage">Number of Message</label>
                                    <input
                                        onChange={(e) => setNoOfmessage(e.target.value)}
                                        id="NoOfmessage"
                                        value={noOfmessage}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Number of Message Name"
                                    />
                            </div> */}

                            {/* <div className="form-group mb-3">
                                    <label htmlFor="NoOfmessage">Number of Buy Contacts</label>
                                    <input
                                        onChange={(e) => setNoOfBuyContacts(e.target.value)}
                                        id="NoOfmessage"
                                        value={noOfBuyContacts}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Number of Buy Contacts"
                                    />
                            </div> */}


                            <div className="form-group mb-3">
                                <label htmlFor="Subscription">Subscription Type</label>
                                <select
                                    onChange={(e) => { setSubType(e.target.value) }}
                                    id="Subscription"
                                    type="text"
                                    className="form-control"
                                    style={{
                                        height: "50px", width: "100%"
                                    }}>
                                    <option>Select Subscription</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="quarterly">Quarterly</option>
                                    <option value="yearly">Yearly</option>
                                </select>
                            </div>
                            

                            <div className="form-group mb-3">
                                    <label htmlFor="price">price</label>
                                    <input
                                        onChange={(e) => setPrice(e.target.value)}
                                        id="price"
                                        value={price}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Price Name"
                                    />
                            </div>

                       

                        <div className="row mt-4">
                            <div className="form-group mb-0 text-center">
                                <button onClick={addPlanApi} className="btn btn-gradient btn-block" type="submit"> Submit </button>
                            </div>
                        </div>
                        {
                            notify.isOpen ?
                                <Notification
                                    notify={notify}
                                    setNotify={setNotify} />
                                : ""
                        }
                    </div>
                </div>
            </div>
            </div>
            </div>
        </>
    )
}

export default AddPlan;